var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { persistent: "", width: "600" },
      model: {
        value: _vm.dialog,
        callback: function($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog"
      }
    },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            { staticClass: "headline" },
            [
              _c(
                "v-flex",
                { attrs: { xs9: "" } },
                [
                  _c("v-icon", [_vm._v(_vm._s(_vm.form.id ? "edit" : "add"))]),
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.form.id ? "Editar CAS" : "Crear CAS") +
                      "\n      "
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { icon: "" },
                  nativeOn: {
                    click: function($event) {
                      return _vm.close()
                    }
                  }
                },
                [_c("v-icon", [_vm._v("close")])],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "form",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                  return _vm.save.apply(null, arguments)
                }
              },
              model: {
                value: _vm.valid,
                callback: function($$v) {
                  _vm.valid = $$v
                },
                expression: "valid"
              }
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-container",
                    { attrs: { "grid-list-md": "" } },
                    [
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      name: "label",
                                      label: "Fecha presentación en ASP-B",
                                      autofocus: "",
                                      maxlength: "50",
                                      rules: _vm.$validate(["required"]),
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.form.fecha_presentacion,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "fecha_presentacion",
                                          $$v
                                        )
                                      },
                                      expression: "form.fecha_presentacion"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs6: "" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      type: "date",
                                      name: "label",
                                      label: "Fecha trámite CAS",
                                      autofocus: "",
                                      maxlength: "50",
                                      rules: _vm.$validate(["required"]),
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.form.fecha_tramite,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "fecha_tramite", $$v)
                                      },
                                      expression: "form.fecha_tramite"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "Number",
                                  min: "0",
                                  name: "label",
                                  label: "Años calificados a la fecha",
                                  autofocus: "",
                                  maxlength: "50",
                                  rules: [
                                    function(v) {
                                      if (v == null) {
                                        return "El campo es obligatorio."
                                      }
                                      if (v < 0) {
                                        return "El campo no puede ser negativo."
                                      }
                                      if (v >= 100) {
                                        return "No puede ingresar un número tan grande."
                                      }
                                      return true
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.form.anios,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "anios", $$v)
                                  },
                                  expression: "form.anios"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "Number",
                                  min: "0",
                                  name: "label",
                                  label: "Meses calificados a la fecha",
                                  autofocus: "",
                                  maxlength: "50",
                                  rules: [
                                    function(v) {
                                      if (v == null) {
                                        return "El campo es obligatorio."
                                      }
                                      if (v < 0) {
                                        return "El campo no puede ser negativo."
                                      }
                                      if (v >= 100) {
                                        return "No puede ingresar un número tan grande."
                                      }
                                      return true
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.form.meses,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "meses", $$v)
                                  },
                                  expression: "form.meses"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs6: "" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "Number",
                                  min: "0",
                                  name: "label",
                                  label: "Dias calificados a la fecha",
                                  autofocus: "",
                                  maxlength: "50",
                                  rules: [
                                    function(v) {
                                      if (v == null) {
                                        return "El campo es obligatorio."
                                      }
                                      if (v < 0) {
                                        return "El campo no puede ser negativo."
                                      }
                                      if (v >= 100) {
                                        return "No puede ingresar un número tan grande."
                                      }
                                      return true
                                    }
                                  ]
                                },
                                model: {
                                  value: _vm.form.dias,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "dias", $$v)
                                  },
                                  expression: "form.dias"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-flex", { attrs: { md12: "" } }, [
                            _c("input", {
                              ref: "file",
                              attrs: {
                                id: "input",
                                type: "file",
                                accept: "image/*, application/pdf",
                                rules: _vm.$validate(["required"]),
                                required: ""
                              },
                              on: {
                                change: function($event) {
                                  return _vm.handleFileUpload()
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.error
                              ? _c("p", { staticClass: "red--text body-1" }, [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(_vm.mensjageerror) +
                                      "\n              "
                                  )
                                ])
                              : _vm._e()
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("small", { staticClass: "error--text text-required" }, [
                    _vm._v("* Los campos son obligatorios")
                  ]),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      nativeOn: {
                        click: function($event) {
                          return _vm.close()
                        }
                      }
                    },
                    [
                      _c("v-icon", [_vm._v("cancel")]),
                      _vm._v(
                        " " + _vm._s(_vm.$t("common.cancel")) + "\n        "
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        type: "submit",
                        loading: _vm.loading,
                        disabled: !_vm.valid
                      }
                    },
                    [
                      _c("v-icon", { attrs: { dark: "" } }, [_vm._v("check")]),
                      _vm._v(" " + _vm._s(_vm.$t("common.save")) + "\n        ")
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6e63240b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e63240b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/ficha_personal/dialogs/CrearActualizarCas.vue
// module id = null
// module chunks = 